import { SPACING } from '@alto/design-library-tokens';
import { Card, LgPadding, MdSpacing } from '@alto/design-system';
import React from 'react';
import { AddressSelector } from '../../../address/components/AddressSelector';
import { AddressInfo } from './address-info/AddressInfo';

type Props = {
  readonly disabled?: boolean; // address selection is disabled for split shipments on the courier shipment
};
export const DeliveryAddressCard = ({ disabled }: Props) => (
  <Card
    title="Delivery address"
    overflow="hidden"
  >
    <LgPadding
      topPadding={SPACING.STATIC.NONE}
      bottomPadding={SPACING.STATIC.NONE}
    >
      <AddressSelector
        disabled={disabled}
        origin="checkout"
      />
    </LgPadding>
    <MdSpacing />
    <AddressInfo />
  </Card>
);
